/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export const CLEAR_SIGN_IN_ERROR = 'CLEAR_SIGN_IN_ERROR';
export const SET_LICENSE_PLATE_URL = 'SET_LICENSE_PLATE_URL';
export const SET_LP_CODE_AND_EXPIRATION = 'SET_LP_CODE_AND_EXPIRATION';
export const SET_SIGN_IN_ERROR = 'SET_SIGN_IN_ERROR';
export const SET_NEW_CODE_BTN_HIGHLIGHT = 'SET_NEW_CODE_BTN_HIGHLIGHT';
